var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { CustomElement, P, Watch, PropertyConverters, Utils } from '@pacem/pacem-core';
import { TAG_MIDDLE_NAME } from '../constants';
import { KnownShader, MaterialElement } from './material';
//namespace Pacem.Components.Drawing3D {
let LineMaterialElement = class LineMaterialElement extends MaterialElement {
    constructor() {
        super(KnownShader.Line);
    }
    propertyChangedCallback(name, old, val, first) {
        super.propertyChangedCallback(name, old, val, first);
        if (!first) {
            switch (name) {
                case 'lineWidth':
                case 'lineJoin':
                case 'lineCap':
                case 'dashArray':
                    this.updateMaterial();
                    break;
            }
        }
    }
    async createMaterial() {
        return Utils.extend({
            lineWidth: this.lineWidth ?? 1,
            lineJoin: this.lineJoin ?? 'round',
            lineCap: this.lineCap ?? 'round',
            dashArray: this.dashArray,
        }, await super.createMaterial());
    }
};
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Number })
], LineMaterialElement.prototype, "lineWidth", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.String })
], LineMaterialElement.prototype, "lineJoin", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.String })
], LineMaterialElement.prototype, "lineCap", void 0);
__decorate([
    Watch({
        emit: false, converter: {
            convert: (attr) => attr?.split(',').map(i => parseInt(i)).filter(i => !Number.isNaN(i)),
            convertBack: (prop) => prop?.join(',')
        }
    })
], LineMaterialElement.prototype, "dashArray", void 0);
LineMaterialElement = __decorate([
    CustomElement({ tagName: `${P}-${TAG_MIDDLE_NAME}-material-line` })
], LineMaterialElement);
export { LineMaterialElement };
